module.exports = __webpack_public_path__ + "static/media/school-community.15dac702.png";